export default function (value, min, max) {
  return value !== null && (value < min || value > max);
}
